import { render } from "./FooterIlesdepaix.vue?vue&type=template&id=3c87a39a&scoped=true"
import script from "./FooterIlesdepaix.vue?vue&type=script&lang=js"
export * from "./FooterIlesdepaix.vue?vue&type=script&lang=js"

import "./FooterIlesdepaix.vue?vue&type=style&index=0&id=3c87a39a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c87a39a"]])

export default __exports__